module.exports = __webpack_public_path__ + "static/media/icon_restoration_pontic_5.62ffd088.svg";